import { PageContent, PageHeader } from '@/components';
import { NavigateWithSearch } from '@/lib/react-router';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';
import { FundSheetAnalysisPage } from './fund-sheet/_pages/FundSheetAnalysisPage';
import { ReviewSheetAnalysisPage } from './review-sheet/_pages/ReviewSheetAnalysisPage';

export const AnalysisRoutes = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route index element={<NavigateWithSearch to="review-sheet" replace />} />
      <Route
        path="review-sheet"
        element={
          <>
            <PageHeader
              title={t('analysis-graph-page')}
              breadcrumbs={[{ title: t('analysis-graph-page') }]}
            />
            <PageContent>
              <ReviewSheetAnalysisPage />
            </PageContent>
          </>
        }
      />
      <Route
        path="fund-sheet"
        element={
          <>
            <PageHeader
              title={t('analysis-graph-page')}
              breadcrumbs={[{ title: t('analysis-graph-page') }]}
            />
            <PageContent>
              <FundSheetAnalysisPage />
            </PageContent>
          </>
        }
      />
    </Routes>
  );
};
